import { defineFieldDisplay } from "../defines";
import RawDisplay from "./raw-display.vue";

export default defineFieldDisplay({
  id: "raw",
  component: RawDisplay,
});
